/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@repo/ui";
import { useState } from "react";
import { ChevronDown, ChevronUp, Settings } from "lucide-react";

export default function SearchCriteriaSettings({
  searchCriteria = [],
  updateCriteria = () => {},
}) {
  const [isOpen, setIsOpen] = useState(false);

  const [filters, setFilters] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(null);

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(e) => {
        setIsOpen(e);
        setFilters(searchCriteria);
      }}
    >
      <DialogTrigger asChild>
        <Button variant="secondary" className="w-max" title="Column Settings">
          <Settings />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-[80vw] max-h-[90vh] h-[90vh] flex flex-col gap-2 overflow-y-scroll">
        <DialogHeader>
          <DialogTitle className="mb-8 mt-8">
            Change Search Criteria Sequence
          </DialogTitle>
        </DialogHeader>

        <div className="flex flex-row gap-2 items-center h-[500px] w-full">
          <div className=" h-full overflow-y-scroll border border-secondary  flex flex-col rounded-sm min-w-[50%]">
            {filters.map((filter, index) => (
              <div
                key={filter.searchName}
                className={`p-2 cursor-pointer ${selectedFilter === index ? "bg-blue-300" : "hover:bg-gray-200"}`}
                onClick={() => {
                  setSelectedFilter(index);
                }}
              >
                {filter.searchName}
              </div>
            ))}
          </div>
          <div className="flex flex-col gap-1">
            <Button
              variant="outline"
              className="border-secondary"
              disabled={selectedFilter === 0}
              onClick={() => {
                if (selectedFilter > 0) {
                  const _filters = [...filters];
                  [_filters[selectedFilter], _filters[selectedFilter - 1]] = [
                    _filters[selectedFilter - 1],
                    _filters[selectedFilter],
                  ];
                  setFilters(_filters);
                  setSelectedFilter(selectedFilter - 1);
                }
              }}
            >
              <ChevronUp color="#000000" />
            </Button>
            <Button
              variant="outline"
              className="border-secondary"
              disabled={selectedFilter === filters.length - 1}
              onClick={() => {
                if (selectedFilter < filters.length) {
                  const _filters = [...filters];
                  [_filters[selectedFilter], _filters[selectedFilter + 1]] = [
                    _filters[selectedFilter + 1],
                    _filters[selectedFilter],
                  ];
                  setFilters(_filters);
                  setSelectedFilter(selectedFilter + 1);
                }
              }}
            >
              <ChevronDown color="#000000" />
            </Button>
          </div>
        </div>
        <div className="flex flex-row gap-2 items-end justify-end">
          <Button
            onClick={() => {
              setIsOpen(false);
              updateCriteria(filters);
            }}
            variant="secondary"
          >
            Save
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
